import React from 'react';
import cn from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import { iFMessage } from '../../../../hoc/IntlComponents';
import { getPreviewStyle } from './getPreviewStyle';

const NewIFrameCounstrucorPreview = ({ settings, forwardRef, intl }) => {
  const style = getPreviewStyle(settings);

  return (
    <div className={cn('iframe-form-preview', style)} id="iframe-preview" ref={forwardRef}>
      <div className="form-container">
        {settings['iframe/20/17/28'] !== 'hide' ? (
          <div className="form-group">
            <label htmlFor="demo-country">
              <FormattedMessage
                id="iframe_constructor.preview.form.select.label"
                defaultMessage="Country"
              />
            </label>
            <select id="demo-country" name="country" className="form-control">
              {[1, 2, 3].map((option) => (
                <option key={option}>
                  {iFMessage({
                    intl,
                    id: `iframe_constructor.preview.form.select.option_${option}`,
                  })}
                </option>
              ))}
            </select>
          </div>
        ) : null}

        <div className="form-group">
          <label htmlFor="demo-name">
            <FormattedMessage
              id="iframe_constructor.preview.form.name.label"
              defaultMessage="Full name"
            />
          </label>
          <input id="demo-name" name="name" className="form-control" />
          {settings['iframe/20/17/29'] ? (
            <small className="form-text">
              <FormattedMessage
                id="iframe_constructor.preview.form.name.example"
                defaultMessage="Example: Tom Johnson"
              />
            </small>
          ) : null}
        </div>

        <div className="form-group">
          <label htmlFor="demo-phone">
            <FormattedMessage
              id="iframe_constructor.preview.form.phone.label"
              defaultMessage="Mob.phone"
            />
          </label>
          <input type="phone" id="demo-phone" name="phone" className="form-control" />
          {settings['iframe/20/17/29'] ? (
            <small className="form-text">
              <FormattedMessage
                id="iframe_constructor.preview.form.phone.example"
                defaultMessage="Example: +44 123456789"
              />
            </small>
          ) : null}
        </div>

        {settings['iframe/20/17/30'] ? (
          <div className="checkbox agreement">
            <label htmlFor="demo-agreement">
              <input id="demo-agreement" type="checkbox" defaultChecked />{' '}
              <FormattedMessage
                id="iframe_constructor.preview.form.agreement"
                defaultMessage="I agree with processing of my personal data"
              />
            </label>
          </div>
        ) : null}

        <button className="btn btn-submit" type="button">
          {settings['iframe/20/16/26']}
        </button>
      </div>
    </div>
  );
};

const NewIFrameCounstrucorPreviewWithIntl = injectIntl(NewIFrameCounstrucorPreview);

export { NewIFrameCounstrucorPreviewWithIntl };
